const VERSION_CORE = /^(\d+)\.(\d+)\.(\d+)/;

type VersionCore = [number, number, number];

/** Major.minor.patch. A build suffix such as `5.3.1-452` is ignored. */
export function parseAppVersionCore(
    value: string | null | undefined,
): VersionCore | null {
    if (!value) {
        return null;
    }
    const match = VERSION_CORE.exec(value.trim());
    if (!match) {
        return null;
    }
    return [Number(match[1]), Number(match[2]), Number(match[3])];
}

function compareVersionCore(left: VersionCore, right: VersionCore): number {
    for (let index = 0; index < 3; index += 1) {
        if (left[index] !== right[index]) {
            return left[index] - right[index];
        }
    }
    return 0;
}

/**
 * True when the running binary is older than minVersion.
 * `0.0.0` never blocks. A missing version blocks only after the minimum is raised.
 */
export function isBelowMinAppVersion(
    appVersion: string | null | undefined,
    minVersion: string | null | undefined,
): boolean {
    const min = parseAppVersionCore(minVersion);
    if (!min || (min[0] === 0 && min[1] === 0 && min[2] === 0)) {
        return false;
    }
    const app = parseAppVersionCore(appVersion);
    if (!app) {
        return true;
    }
    return compareVersionCore(app, min) < 0;
}
